// Resources

<template>
  <section class="lms3100-container">
    <div class="lms3100 white border-main shadow-dark">
      <Ul class="crumbs text-charcoal mb-2">
        <li><sym-link to="/">Home</sym-link></li>
        <li><span aria-current="page">Resources</span></li>
      </Ul>

      <div class="p-2 lams curved border-lightgray mb-4">
        <h5 class="serif mb-0">
          <i class="fa fa-download ml-1 mr-2"></i>Resources
        </h5>
      </div>

      <div class="resources">
        <!-- <div class="box-border resource" @click="onClick('lms3110')">
        <div class="media">
          <img class="mr-3 border-main info-light thumb curved" src="img/resources-1.png">
          <div class="media-body">
            <h5 class="mt-1">CADTs Files</h5>
            <p>
              A curated collection of Ancestral Domain-related files intended
              for DENR Bureaus and Regional Offices.
            </p>
          </div>
        </div>

        <button type="button" class="warning darken-2 shadow w-100 text-center mt-2" @click="onClick('lms3110')">Show me &raquo;</button>
      </div> -->

        <div class="box-border resource" @click="onClick('lms3130')">
          <div class="media">
            <img
              class="mr-3 border-main info-light thumb curved"
              src="img/resources-3.png"
            />
            <div class="media-body">
              <h5 class="mt-1">LAMS Packages</h5>
              <p>
                A collection of software releases, patches and updates intended
                for Administrators of Regional Offices.
              </p>
            </div>
          </div>

          <button
            type="button"
            class="warning darken-2 shadow w-100 text-center mt-2"
            @click="onClick('lms3130')"
          >
            Get updates &raquo;
          </button>
        </div>

        <div class="box-border resource" @click="onClick('lms3120')">
          <div class="media">
            <!-- <img class="mr-3 border-main thumb curved" src="../../img/resources-2.jpg"> -->
            <!-- public folder -->
            <img
              class="mr-3 border-main thumb curved"
              src="img/resources-2.jpg"
            />
            <div class="media-body">
              <h5 class="mt-1">
                e-SurveyPlan <span class="sm-2">(for Windows)</span>
              </h5>
              <p>
                Discover the convenience of digital submission of survey plans.
                Get your FREE copy of <b>e-SurveyPlan</b> now!
              </p>
            </div>
          </div>

          <button
            type="button"
            class="warning darken-2 shadow w-100 text-center mt-2"
            @click="onClick('lms3120')"
          >
            Get my FREE copy &raquo;
          </button>
        </div>
      </div>

      <button
        type="button"
        class="primary text-center w-100 lg-1 shadow mt-2 mb-2"
        @click="goBack()"
      >
        <i class="fa fa-arrow-left mr-2"></i> Back
      </button>
    </div>
  </section>
</template>

<script>
import PageBase from "../PageBase.vue";

export default {
  extends: PageBase,
  name: "lms3100",

  methods: {
    // event handlers

    onClick(pageId) {
      let route = {
        name: pageId,
      };
      // eslint-disable-next-line no-console
      console.log("test");
      this.go(route);
    },
  },
};
</script>

<style scoped>
.lms3100-container {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
  padding-bottom: 3rem;
}

.lms3100 {
  width: 80%;
  padding: 1rem 2rem;
  border-radius: 0.375rem;
}

.resource {
  padding: 1rem;
  margin-bottom: 1rem;
  position: relative;
}

.thumb {
  width: 40%;
}

.resources {
  display: grid;
  /* grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); */
  grid-template-columns: repeat(2, 1fr);
  row-gap: 1rem;
  column-gap: 1.5rem;
}

.resource::after {
  box-shadow: 2px 2px 16px 8px rgba(48, 48, 48, 0.3);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  content: " ";
}

.resource:hover::after {
  opacity: 1;
}

.resource:hover {
  background-color: beige;
  cursor: pointer;
}

@media (max-width: 1024px) {
  .lms3100 {
    width: 90%;
    padding: 2rem;
  }
}

@media (max-width: 960px) {
  .lms3100-container {
    padding-top: 0;
    padding-bottom: 0;
  }

  .lms3100 {
    width: 100%;
    padding: 1rem;
    border-radius: 0;
  }
}

@media (max-width: 768px) {
  .resources {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 420px) {
  .lms3100 {
    padding: 0.5rem;
  }

  .resource {
    padding: 0.5rem;
  }

  .thumb {
    width: 40%;
  }
}
</style>
